import { useSyncExternalStore } from 'react'

function getSnapshot(): boolean {
  return navigator.onLine
}

function subscribe(callback: () => void): () => void {
  window.addEventListener('online', callback)
  window.addEventListener('offline', callback)
  return () => {
    window.removeEventListener('online', callback)
    window.removeEventListener('offline', callback)
  }
}

export function useNetworkStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true)
}
